import type { ScaleLinear, ScaleTime } from '@visx/vendor/d3-scale';
import { createContext, useContext } from 'react';

export interface ChartContextValue {
  dates: readonly Date[];
  xScale: ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
  innerWidth: number;
  innerHeight: number;
  /** Hovered month index, or −1. */
  hoverIndex: number;
  /** Visible month-index window [from, to]. */
  range: readonly [number, number];
}

export const ChartContext = createContext<ChartContextValue | null>(null);

export function useChart(): ChartContextValue {
  const ctx = useContext(ChartContext);
  if (!ctx) throw new Error('Chart layers must be rendered inside <ChartFrame>');
  return ctx;
}
